const auth = async (url, email, password) => {
  try {
    const response = await fetch(`${url}/auth/signin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      throw new Error("Authentication failed");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during authentication:", error);
    throw error;
  }
};

const getAllFormOnSite = async (url, token, siteId) => {
  try {
    const response = await fetch(`${url}/form/?siteId=${siteId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Get all form failed");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during Get all form:", error);
    throw error;
  }
};

const submitPostFeedback = async (
  url,
  token,
  siteId,
  formId,
  rating,
  comment,
  ticketId
) => {
  try {
    const response = await fetch(`${url}/formlog/submit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        formId: formId,
        siteId: siteId,
        ticketId,
        submittedData: {
          rating: rating,
          comment: comment,
        },
      }),
    });

    if (!response.ok) {
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error during Submit feedback:", error);
    return false;
  }
};

const submitTicketRating = async (url, token, rating, ticketId) => {
  try {
    const response = await fetch(`${url}/ticket/feedback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ticketId: ticketId,
        rating: rating,
      }),
    });

    if (!response.ok) {
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error during Submit feedback:", error);
    return false;
  }
};

export const submitApplicationFeedBack = async (
  baseUrl,
  email,
  password,
  siteId,
  rating,
  comment,
  formId,
  ticketId
) => {
  try {
    // auth
    const responseAuth = await auth(baseUrl, email, password);

    if (responseAuth.accessToken) {
      const response = await submitPostFeedback(
        baseUrl,
        responseAuth.accessToken,
        siteId,
        formId,
        rating,
        comment,
        ticketId
      );

      // const responseTicketRating = await submitTicketRating(
      //   baseUrl,
      //   responseAuth.accessToken,
      //   rating,
      //   ticketId
      // );

      return response;
    }
    return false;
  } catch (error) {
    console.log(error);
    return false;
  }
};
